var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.galleryID}},[_c('div',{staticClass:"d-flex flex-wrap",staticStyle:{"gap":"5px"}},_vm._l((_vm.images),function(item,index){return _c('gallery-item',{key:`item-${_vm.galleryID}-${index}`,attrs:{"item":item,"index":index,"type":_vm.getType(item),"grid":_vm.grid}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }